import React, { useEffect, useState } from "react";
import { postAPIHandler } from "../../../Api/api";

const TeamRanking = ({ formatTypes }) => {
  const [teamRanking, setTeamRanking] = useState([]);

  useEffect(() => {
    GetTeamRanking();
  }, [formatTypes]);

  const GetTeamRanking = async () => {
    const formData = new FormData();
    formData.append(
      "type",
      formatTypes === "ODI" ? 1 : formatTypes === "Test" ? 2 : 3
    );

    const response = await postAPIHandler("teamRanking", formData);
    const data = response.data;

    const uniqueData = Array.isArray(data)
      ? data.filter(
        (team, index, self) =>
          index ===
          self.findIndex((t) => t.rank === team.rank && t.team === team.team)
      )
      : [];

    const sortedData = uniqueData.sort((a, b) => a.rank - b.rank);
    setTeamRanking(sortedData);
  };

  return (
    <div className="">
      <div className="flex flex-wrap justify-between">
        {teamRanking.map((team, index) => (
          <div className=" lg:w-[23%] md:w-[47%] w-[100%]  bg-[#242424] mx-2 my-2 px-3 py-2 rounded-[8px] flex items-center border-b-4 border-[#252927] " key={index}>
            <img
              src={team.flag}
              alt={team.flag}
              className="w-12 rounded-[30px] mr-3 object-fit-cover object-top"
            />
            <p className="text-[#ffffff] text-[20px] font-medium mb-0">
              {team.team}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamRanking;
